/**
 * Admin Monitoring System
 * Unified admin security monitoring and telemetry
 *
 * Usage:
 *   import { attachFetchGuard, trackAdminCallOnPublicRoute } from '@/lib/monitoring/admin'
 *   attachFetchGuard() // Enable automatic fetch monitoring
 */

// Core functionality
export { trackAdminCallOnPublicRoute, attachFetchGuard } from './guard';
export { raiseSecurityAlert, trackAdminCall, trackDeprecatedCall } from './telemetry';
export { setAdminGuardShell, getAdminGuardShell } from './bus';
export type { AdminGuardShell } from './bus';

// Note: Legacy call monitor functions have been consolidated into the core system
// These functions are available through the unified guard and telemetry modules

// Auto-initialize fetch guard
import { attachFetchGuard } from './guard';

if (typeof window !== 'undefined') {
  attachFetchGuard();
}